import './bootstrap';
import './jquery';
import './vue';
require('admin-lte');
require('jszip');
//require('pdfmake');
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-responsive-bs4');
//require('select2');

/**
 * Moment.js
 */
import moment from 'moment';
require("moment/locale/es");

moment.locale("es");
window.moment = moment;

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
